<div class="sub-request-table-container">
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChanged($event)" class="mat-elevation-z1 full-width plain-table">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('id'), integerOnly: true }">
          {{ 'commonPackagingFields.id' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ sub.id }}</td>
    </ng-container>

    <ng-container matColumnDef="articleName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('articleName') }">
          {{ 'component.fields.articleName' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleName'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ getArticleName(sub) }}</td>
    </ng-container>

    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('productName') }">
          {{ 'packagingUnit.fields.productName' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('productName'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ getProductName(sub) }}</td>
    </ng-container>

    <ng-container matColumnDef="brandName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('brandName') }">
          {{ 'packagingUnit.fields.brandName' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('brandName'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ getBrandName(sub) }}</td>
    </ng-container>

    <ng-container matColumnDef="articleNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('articleNumber') }">
          {{ 'component.fields.articleNumber' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleNumber'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ getArticleNumber(sub) }}</td>
    </ng-container>

    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('manufacturer') }">
          {{ 'material.fields.manufacturer' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('manufacturer'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ getManufacturer(sub) }}</td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('packagingComponentType'), categories: getPackagingComponentTypeOptions() }">
          {{ 'component.componentType' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingComponentType'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">
        <img *ngIf="sub.packagingComponent" [src]="getPackagingComponentTypeImage(sub)" class="type-icon" [matTooltip]="getPackagingComponentType(sub)" />
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('packagingType'), categories: getPackagingTypeOptions() }">
          {{ 'packagingUnit.packagingUnitType' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingType'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">
        <img *ngIf="sub.packagingUnitInfo" [src]="getPackagingTypeImage(sub)" class="type-icon" [matTooltip]="getPackagingType(sub)" />
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('status'), categories: getStatusOptions() }">
          {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('status'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ getStatusLabel(sub.status) | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="lastModificationTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()">
          {{ 'dataManagement.dataExchangeRequests.columns.lastModifiedAt' | transloco }}
        </button>
      </th>
      <td mat-cell *matCellDef="let sub">{{ getDate(sub.lastModifiedAt) | date: 'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="showSubRequestComments">
      <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
      <td mat-cell *matCellDef="let sub" style="width: 48px">
        <button mat-icon-button type="button" (click)="showSubRequestComments.emit(sub); $event.stopPropagation()">
          <mat-icon [matBadge]="sub.comments?.length" [matBadgeHidden]="!sub.comments?.length" matBadgeColor="primary" matBadgeSize="small">comment</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef style="width: 148px; text-align: center">{{ 'dataManagement.actions' | transloco }}</th>
      <td mat-cell *matCellDef="let sub" style="width: 148px">
        <button mat-icon-button type="button"
          [title]="'dataManagement.dataExchangeRequests.actions.openSubRequest' | transloco"
          [disabled]="sub.status === requestStatus.Deleted"
          (click)="navigateToSubRequest.emit(sub); $event.stopPropagation()">
          <mat-icon>open_in_new</mat-icon>
        </button>
        <ng-container *ngIf="!isReceived">
          <button mat-icon-button type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco"
            [disabled]="sub.status !== requestStatus.Submitted"
            (click)="approveSubRequest.emit(sub); $event.stopPropagation()">
            <mat-icon>check_circle</mat-icon>
          </button>
          <button mat-icon-button type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco"
            [disabled]="sub.status !== requestStatus.Submitted"
            (click)="reopenSubRequest.emit(sub); $event.stopPropagation()">
            <mat-icon>replay</mat-icon>
          </button>
          <button mat-icon-button type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.withdrawSubRequest' | transloco"
            [disabled]="sub.status === requestStatus.Deleted"
            (click)="withdrawSubRequest.emit(sub); $event.stopPropagation()">
            <mat-icon>undo</mat-icon>
          </button>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        {{ 'dataManagement.dataExchangeRequests.noData' | transloco }}
      </td>
    </tr>
  </table>

  <div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="40" color="accent"></mat-spinner>
  </div>

  <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
</div>

<mat-paginator class="sub-request-paginator" [length]="1" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page" (page)="onPageChanged($event)"></mat-paginator>
